import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as i}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as l}from"../../icon-registry.js";const d=l("libya",i`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19470_85961)">
                <path
                    d="M24.0003 4.5H-0.000488281V20.5H24.0003V4.5Z"
                    fill="#239E46" />
                <path
                    d="M23.9995 4.5H-0.000488281V16.5H23.9995V4.5Z"
                    fill="black" />
                <path
                    d="M23.9995 4.5H-0.000488281V8.5H23.9995V4.5Z"
                    fill="#E70013" />
                <path
                    d="M11.2772 14.5C12.2361 14.5 13.0134 13.6046 13.0134 12.5C13.0134 11.3954 12.2361 10.5 11.2772 10.5C10.3183 10.5 9.54102 11.3954 9.54102 12.5C9.54102 13.6046 10.3183 14.5 11.2772 14.5Z"
                    fill="white" />
                <path
                    d="M11.6315 14.2371C12.4646 14.2371 13.14 13.4591 13.14 12.4994C13.14 11.5397 12.4646 10.7617 11.6315 10.7617C10.7984 10.7617 10.123 11.5397 10.123 12.4994C10.123 13.4591 10.7984 14.2371 11.6315 14.2371Z"
                    fill="black" />
                <path
                    d="M12.124 12.5003L14.4592 11.6263L13.0158 13.9146V11.0859L14.4592 13.3743L12.124 12.5003Z"
                    fill="white" />
            </g>
            <defs>
                <clipPath id="clip0_19470_85961">
                    <rect
                        width="24"
                        height="24"
                        fill="white"
                        transform="translate(0 0.5)" />
                </clipPath>
            </defs>
        </svg>
    `),e=l("libya_rounded",i`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19470_85962)">
                <rect
                    y="0.5"
                    width="24"
                    height="24"
                    rx="12"
                    fill="#FF4E4E" />
                <path
                    d="M36 0.5H-12V24.5H36V0.5Z"
                    fill="#239E46" />
                <path
                    d="M36 0.5H-12V18.5H36V0.5Z"
                    fill="black" />
                <path
                    d="M36 0.5H-12V6.5H36V0.5Z"
                    fill="#E70013" />
                <path
                    d="M12 15.5C13.6569 15.5 15 14.1569 15 12.5C15 10.8431 13.6569 9.5 12 9.5C10.3431 9.5 9 10.8431 9 12.5C9 14.1569 10.3431 15.5 12 15.5Z"
                    fill="white" />
                <path
                    d="M12.6065 15.1066C14.046 15.1066 15.213 13.9396 15.213 12.5001C15.213 11.0605 14.046 9.89355 12.6065 9.89355C11.167 9.89355 10 11.0605 10 12.5001C10 13.9396 11.167 15.1066 12.6065 15.1066Z"
                    fill="black" />
                <path
                    d="M13.4609 12.5004L17.4959 11.1894L15.0019 14.6219V10.3789L17.4959 13.8114L13.4609 12.5004Z"
                    fill="white" />
            </g>
            <defs>
                <clipPath id="clip0_19470_85962">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{d as Libya,e as LibyaRounded};
